const theme = {
	spacing: 4,
	typography: {
		h6: {
			fontWeight: 'bold',
		},
	},
};
export default theme;
